import { resizeCrestToJpegDataUrl } from './normalizeCrestImage';

const BRAND_LOGO_PATHS = {
  your_tour: '/Your%20Tour%20logo.jpeg',
  padelante: '/Padelante%20Logo.png',
  mst:       '/MST%20Logo%20White%20Letter.png', // 400px copy — keeps the PDF small
};

// The parent-facing "letter to parents" quote + confirmation letters cover
// Your Tour and MST tours going UK → Spain. Padelante and the Spanish-language
// Spain → UK tours keep the generic cost-breakdown quote letter.
export function usesParentLetters(request) {
  const brand = request?.brand || 'mst';
  return (brand === 'your_tour' || brand === 'mst') && request?.market !== 'spain_to_uk';
}

async function fetchAsDataUrl(url) {
  const blob = await (await fetch(url)).blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

// Brand logo as a data URL for the letter PDFs — null if it can't be fetched
// (the PDFs fall back to a text badge).
export async function loadBrandLogoDataUrl(brand) {
  const path = BRAND_LOGO_PATHS[brand || 'mst'];
  if (!path) return null;
  try { return await fetchAsDataUrl(path); } catch (_) { return null; }
}

// The tour's saved crest, resized for the PDF — null if none / fetch fails.
export async function loadSavedCrestDataUrl(crestUrl) {
  if (!crestUrl) return null;
  try { return await resizeCrestToJpegDataUrl(await fetchAsDataUrl(crestUrl)); } catch (_) { return null; }
}
